module.exports = __webpack_public_path__ + "static/logo@3x.5c7df546.png";